module.exports = {
  'name': 'combinations',
  'category': 'Probability',
  'syntax': [
    'combinations(n, k)'
  ],
  'description': 'Compute the number of combinations of n items taken k at a time',
  'examples': [
    'combinations(7, 5)'
  ],
  'seealso': ['permutations', 'factorial']
};



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/docs/function/probability/combinations.js
// module id = 1032
// module chunks = 0